import { Action, createReducer, on } from '@ngrx/store';
import { IAppState, IErrorState } from '../../utils/interfaces/store.interfaces';
import { errorEventAction } from '../actions/app.actions';
import { IDataAction } from 'src/app/utils/interfaces/common.interfaces';

const initialState: IAppState = {
  errorEvent: null
};

export const appReducerImplicit = createReducer(
  initialState,
  on(errorEventAction, (state, { data: httpErrorResponse }: IDataAction<IErrorState>) => ({
    ...state,
    errorEvent: { ...httpErrorResponse, date: new Date() },
  }))
);

export function appReducer(state: any, action: Action) {
  return appReducerImplicit(state, action);
}
